module.exports = "/_next/static/images/icon_map-5a422f4064334377262ce12b1c0bc5eb.svg";